// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-11322bad] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.counter-bubble__counter[data-v-11322bad] {
  --counter-bubble-height: 22px;
  font-size: var(--font-size-small, 13px);
  overflow: hidden;
  width: fit-content;
  min-width: var(--counter-bubble-height);
  text-align: center;
  line-height: var(--counter-bubble-height);
  padding: 0 calc(1.5 * var(--default-grid-baseline));
  border-radius: var(--border-radius-pill);
  background-color: var(--color-primary-element-light);
  font-weight: bold;
  color: var(--color-primary-element-light-text);
}
.counter-bubble__counter .active[data-v-11322bad] {
  color: var(--color-main-background);
  background-color: var(--color-primary-element-light);
}
.counter-bubble__counter--highlighted[data-v-11322bad] {
  color: var(--color-primary-element-text);
  background-color: var(--color-primary-element);
}
.counter-bubble__counter--highlighted.active[data-v-11322bad] {
  color: var(--color-primary-element);
  background-color: var(--color-main-background);
}
.counter-bubble__counter--outlined[data-v-11322bad] {
  color: var(--color-primary-element);
  background: transparent;
  box-shadow: inset 0 0 0 2px;
}
.counter-bubble__counter--outlined.active[data-v-11322bad] {
  color: var(--color-main-background);
  box-shadow: inset 0 0 0 2px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcCounterBubble-DdYmHnng.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,yCAAyC;EACzC,mDAAmD;EACnD,wCAAwC;EACxC,oDAAoD;EACpD,iBAAiB;EACjB,8CAA8C;AAChD;AACA;EACE,mCAAmC;EACnC,oDAAoD;AACtD;AACA;EACE,wCAAwC;EACxC,8CAA8C;AAChD;AACA;EACE,mCAAmC;EACnC,8CAA8C;AAChD;AACA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-11322bad] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.counter-bubble__counter[data-v-11322bad] {\n  --counter-bubble-height: 22px;\n  font-size: var(--font-size-small, 13px);\n  overflow: hidden;\n  width: fit-content;\n  min-width: var(--counter-bubble-height);\n  text-align: center;\n  line-height: var(--counter-bubble-height);\n  padding: 0 calc(1.5 * var(--default-grid-baseline));\n  border-radius: var(--border-radius-pill);\n  background-color: var(--color-primary-element-light);\n  font-weight: bold;\n  color: var(--color-primary-element-light-text);\n}\n.counter-bubble__counter .active[data-v-11322bad] {\n  color: var(--color-main-background);\n  background-color: var(--color-primary-element-light);\n}\n.counter-bubble__counter--highlighted[data-v-11322bad] {\n  color: var(--color-primary-element-text);\n  background-color: var(--color-primary-element);\n}\n.counter-bubble__counter--highlighted.active[data-v-11322bad] {\n  color: var(--color-primary-element);\n  background-color: var(--color-main-background);\n}\n.counter-bubble__counter--outlined[data-v-11322bad] {\n  color: var(--color-primary-element);\n  background: transparent;\n  box-shadow: inset 0 0 0 2px;\n}\n.counter-bubble__counter--outlined.active[data-v-11322bad] {\n  color: var(--color-main-background);\n  box-shadow: inset 0 0 0 2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
